import {Service} from '@s-ui/domain'

const AJS_USER_COOKIE_NAME = 'ajs_user_id'

export class GetResetTrackingDataService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.cookieRepository
   * @param {Service} deps.getCurrentUserService
   * @param {Repository} deps.repository
   */
  constructor({cookieRepository, getCurrentUserService, repository}) {
    super()

    this._cookieRepository = cookieRepository
    this._getCurrentUserService = getCurrentUserService
    this._repository = repository
  }

  /**
   * @method
   * @private
   * @return {Boolean} Returns if tracking event needs to reset the user.
   */
  async _needsReset({user}) {
    if (user) return false
    if (!user && this._cookieRepository.hasCookie(AJS_USER_COOKIE_NAME)) return true
    const session = await this._repository.getExpiredSession()
    return session ? this._repository.removeSession({session}) : false
  }

  /**
   * @return {Promise<Object, Error>} This is a Promise return value.
   */
  async execute() {
    const userEntity = await this._getCurrentUserService.execute()
    const user = userEntity?.toJSON?.()

    const reset = await this._needsReset({user})

    return reset
  }
}
